import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Typography,
  Skeleton,
  Avatar,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { useStore } from "stores/useStore";
import { useState } from "react";
import { observer } from "mobx-react-lite";
import {
  drawerSx,
  drawerClosedSx,
  logoBoxSx,
  listItemButtonSx,
  listItemIconSx,
  dividerSx,
  ListItemTextSx,
} from "../styles/layouts/Sidebar.styles";
import gestionStockLogo from "assets/logos/gestionStockLogo.png";
import {
  HistoryOutlined,
  ShoppingCartOutlined,
  DashboardOutlined,
  Inventory2Outlined,
  WarehouseOutlined,
  BusinessOutlined,
  PeopleAltOutlined,
  CategoryOutlined,
  PaidOutlined,
} from "@mui/icons-material";

const Sidebar = observer(() => {
  const { authStore } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(false);
  const companyName = authStore?.user?.company?.name || "Gestion de stock";

  const handleLogout = () => {
    authStore.logout(true);
    navigate("/");
  };

  const menuItems = [
    {
      label: "Tableau de bord",
      icon: <DashboardOutlined />,
      path: "/dashboard",
      roles: ["super_admin", "admin", "manager", "employee"],
    },
    {
      label: "Entreprises",
      icon: <BusinessOutlined />,
      path: "/companies",
      roles: ["super_admin"],
    },
    {
      label: "Utilisateurs",
      icon: <PeopleAltOutlined />,
      path: "/users",
      roles: ["super_admin", "admin"],
    },
    {
      label: "Catégories",
      icon: <CategoryOutlined />,
      path: "/categories",
      roles: ["super_admin", "admin", "manager", "employee"],
    },
    {
      label: "Dépôts",
      icon: <WarehouseOutlined />,
      path: "/depots",
      roles: ["super_admin", "admin", "manager", "employee"],
    },
    {
      label: "Produits",
      icon: <Inventory2Outlined />,
      path: "/products",
      roles: ["admin", "manager", "employee"],
    },
    {
      label: "Charges",
      icon: <PaidOutlined />,
      path: "/charges",
      roles: ["admin", "manager"],
    },
    {
      label: "Ventes",
      icon: <ShoppingCartOutlined />,
      path: "/sales",
      roles: ["admin"],
    },
    {
      label: "Historique",
      icon: <HistoryOutlined />,
      path: "/history",
      roles: ["admin"],
    },
    //   {
    //   label: "Comptabilité",
    //   icon: <ReceiptLongOutlined />,
    //   path: "/accounting",
    //   roles: ["admin", "manager"],
    // },
    // {
    //   label: "Rapports",
    //   icon: <InsertChartOutlined />,
    //   path: "/reports",
    //   roles: ["admin", "manager", "employee"],
    // },
  ];

  return (
    <Box onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <Drawer variant="permanent" sx={open ? drawerSx : drawerClosedSx}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent={open ? "space-between" : "center"}
          px={2}
          py={2}
        >
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            onClick={() => setOpen(!open)}
            sx={logoBoxSx}
          >
            <Avatar
              variant="square"
              alt={companyName}
              src={gestionStockLogo}
              sx={{ width: 30, height: 30 }}
            />
            {open && (
              <Typography variant="h6" fontWeight="bold" noWrap>
                {companyName}
              </Typography>
            )}
          </Box>
        </Box>

        <Divider sx={dividerSx} />

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "start",
            flexDirection: "column",
          }}
        >
          {authStore.user ? (
            <List>
              {menuItems
                .filter((item) => item.roles.includes(authStore.user?.role))
                .map((item, index) => (
                  <ListItemButton
                    key={index}
                    onClick={() => navigate(item.path)}
                    selected={location.pathname === item.path}
                    sx={{
                      ...listItemButtonSx,
                      borderRight:
                        location.pathname === item.path
                          ? "4px solid #f0f2f5"
                          : "none",
                      paddingRight: location.pathname === item.path ? 2 : 3,
                      backgroundColor:
                        location.pathname === item.path
                          ? "rgba(255,255,255,0.1)"
                          : "transparent",
                    }}
                  >
                    <ListItemIcon sx={listItemIconSx}>{item.icon}</ListItemIcon>
                    {open && (
                      <ListItemText primary={item.label} sx={ListItemTextSx} />
                    )}
                  </ListItemButton>
                ))}
            </List>
          ) : (
            <List>
              {[...Array(5)].map((_, i) => (
                <ListItemButton key={i}>
                  <ListItemIcon>
                    <Skeleton variant="circular" width={24} height={24} />
                  </ListItemIcon>
                  {open && (
                    <ListItemText
                      primary={<Skeleton variant="text" width={100} />}
                    />
                  )}
                </ListItemButton>
              ))}
            </List>
          )}
        </Box>

        <Divider sx={dividerSx} />

        <List>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon sx={{ color: "#fff" }}>
              <LogoutIcon />
            </ListItemIcon>
            {open && <ListItemText primary="Déconnexion" />}
          </ListItemButton>
        </List>
      </Drawer>
    </Box>
  );
});

export default Sidebar;
